import React from 'react';

import moment from 'moment';
import { Input, Tooltip, Select, Button, DatePicker, Modal } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';

import Loading from '../../common/Loading';
import _ from 'lodash';

import { graphql, withApollo } from 'react-apollo';

import getOrganismoPorId from '../../../graphql/querys/organismos/getOrganismoPorId.graphql';
import getUsuariosPorOrganismo from '../../../graphql/querys/auth/getUsuariosPorOrganismo.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;

@graphql(getUsuario)
class FormCrearTraspaso extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
      organismo: {},
      listaUsuarios: [],
      responsable: {},
    };

    // console.log("ENTRE!");
    let yo = this;
    props.client
      .query({
        query: getOrganismoPorId,
        variables: {
          _id: props.data.getUsuario.organismo._id,
        },
      })
      .then(res => {
        this.setState({
          ...this.state,
          organismo: res.data.getOrganismoPorId,
          responsable: res.data.getOrganismoPorId.responsable,
        });
      })
      .catch(err => {
        console.log('ERROR A LA HORA DE BUSCAR EL ORGANISMO!');
        console.log(err);

        Modal.error({
          title: 'Error en la obtencion del organismo',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
          onOk() {
            yo.props.history.push('/');
          },
        });
      });

    props.client
      .query({
        query: getUsuariosPorOrganismo,
        variables: {
          idOrganismo: props.data.getUsuario.organismo._id,
        },
      })
      .then(res => {
        this.setState({
          ...this.state,
          listaUsuarios: res.data.getUsuariosPorOrganismo,
        });
      })
      .catch(err => {
        console.log('ERROR A LA HORA DE BUSCAR EL ORGANISMO!');
        console.log(err);

        let yo = this;
        Modal.error({
          title: 'Error en la obtencion de los usuarios de un organismo',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
          onOk() {
            yo.props.history.push('/');
          },
        });
      });
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSubmit(values);
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  handleChange = valor => {
    this.setState({
      ...this.state,
      itemTipoSeleccionado: valor,
    });
  };

  crearOpciones(usuario) {
    return (
      <Option key={usuario._id} value={usuario._id}>
        {usuario.nombre + ' ' + usuario.apellido}
      </Option>
    );
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    let organismoUsuario = this.state.organismo;
    let listaUsuariosOrganismo = this.state.listaUsuarios;

    if (listaUsuariosOrganismo) {
      var opciones = _.map(listaUsuariosOrganismo, this.crearOpciones);
    } else {
      return <Loading />;
    }

    return (
      <div>
        <h1 className="tituloForm">Datos del Traspaso</h1>
        <Form
          onSubmit={this.handleSubmit}
          style={{ marginTop: 50, marginRight: 40, color: '#000000' }}
        >
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Lugar
                <Tooltip title="Seleccione el organismo">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('idOrganismo', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingrese el organismo!',
                },
              ],
              initialValue: organismoUsuario._id,
            })(
              <Select
                showSearch
                style={{ width: 500, color: '#000000' }}
                placeholder="Seleccione un organismo"
                optionFilterProp="children"
                disabled={true}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option key={organismoUsuario._id} value={organismoUsuario._id}>
                  {organismoUsuario.nombre}
                </Option>
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label={
              <span>
                Fecha y Hora
                <Tooltip title="Fecha y hora que se efectuará el traspaso ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('fechaEstimada', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingrese la fecha y hora del traspaso!',
                },
              ],
              initialValue: null,
            })(
              <DatePicker
                showTime={{
                  minuteStep: 10,
                  format: 'HH:mm',
                }}
                format="DD-MM-YYYY HH:mm"
                placeholder="Seleccionar Fecha y Hora"
                style={{ color: '#000000', width: 500 }}
              />
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Quien entrega
                <Tooltip title="Seleccione el juez saliente">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('idUsuarioSaliente', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingrese el juez saliente!',
                },
              ],
              initialValue: this.state.responsable
                ? this.state.responsable._id
                : '',
            })(
              <Select
                showSearch
                style={{ width: 500, color: '#000000' }}
                placeholder="Seleccione quien entrega"
                optionFilterProp="children"
                disabled={true}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {opciones}
              </Select>
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Quien recibe
                <Tooltip title="Seleccione el juez entrante">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('idUsuarioEntrante', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingrese el juez entrante!',
                },
              ],
            })(
              <Select
                showSearch
                style={{ width: 500, color: '#000000' }}
                placeholder="Seleccione quien recibe"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {opciones}
              </Select>
            )}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Motivo
                <Tooltip title="Motivo del traspaso ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('motivo', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingrese el motivo del traspaso!',
                },
              ],
            })(<Input style={{ color: '#000000', width: 500 }} />)}
          </FormItem>

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Observaciones
                <Tooltip title="Observaciones del traspaso ">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('observacionEntrega')(
              <TextArea style={{ color: '#000000', width: 500 }} rows={6} />
            )}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Confirmar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    return {
      fechaEstimada: Form.createFormField({
        value: props.datos ? moment(props.datos.fechaEstimada) : null,
      }),
      idUsuarioEntrante: Form.createFormField({
        value: props.datos ? props.datos.usuarioEntrante._id : '',
      }),
      motivo: Form.createFormField({
        value: props.datos ? props.datos.motivo : '',
      }),
      observacionEntrega: Form.createFormField({
        value: props.datos ? props.datos.observacionEntrega : '',
      }),
    };
  },
})(withApollo(FormCrearTraspaso));
